import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import SyncIcon from "@mui/icons-material/Sync";
import { useNavigate } from "react-router-dom";
import {
  GridRowModes,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  GridToolbarExport,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";

const EditToolbar = (props) => {
  const { setBranchesData, setRowModesModel, isAdmin } = props;

  let navigate = useNavigate();
  const handleAddClick = () => {
    const id = 0;
    setBranchesData((oldRows) => [
      ...oldRows,
      {
        id,
        branchName: "",
        title: "",
        street: "",
        zip: "",
        regionId: 0,
        tel: "",
        fax: "",
        f_Name: "",
        f_Street: "",
        f_zip: "",
        www: "",
        isNew: true,
      },
    ]);
    setRowModesModel((oldModel) => ({
      ...oldModel,
      [id]: { mode: GridRowModes.Edit, fieldToFocus: "branchName" },
    }));
  };

  function handleRefresh() {
    navigate(0);
  }

  return (
    <GridToolbarContainer>
      <Button
        color="primary"
        startIcon={<AddIcon />}
        onClick={handleAddClick}
        disabled={!isAdmin}
      >
        Neu
      </Button>

      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      <GridToolbarDensitySelector />
      <GridToolbarExport
        csvOptions={{
          fileName: "Abrechnungstelle",
          delimiter: ";",
          utf8WithBom: true,
        }}
      />

      <GridToolbarQuickFilter />
      <Button color="primary" startIcon={<SyncIcon />} onClick={handleRefresh}>
        Refresh
      </Button>
    </GridToolbarContainer>
  );
};

EditToolbar.propTypes = {
  setRowModesModel: PropTypes.func.isRequired,
  setBranchesData: PropTypes.func.isRequired,
  isAdmin: PropTypes.bool,
};

export default EditToolbar;